import { FC } from 'react';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { pageAnimation } from '@const/animation';
import { motion } from 'framer-motion';
import Typography from '@components/common/typography';

import { useLocales } from '@hooks/helpers/useLocales';

interface IProps {
    onSubmit: () => void;
}

const GetReady: FC<IProps> = ({ onSubmit }) => {
    const { submitLocale } = useLocales();
    return (
        <div className={styles.main_wrapper}>
            <motion.div {...pageAnimation} className={styles.wrapper}>
                <div className={styles.text_wrapper}>
                    <Typography alignment="center" variant="h4" className={styles.title}>
                        Make sure an authenticator app is installed
                    </Typography>
                    <Typography alignment="center" variant="body3" className={styles.description}>
                        Before you begin, ensure you have an authenticator app installed on your
                        device. You can use any app, such as Google Authenticator, Microsoft
                        Authenticator, or Authy.
                    </Typography>
                </div>
                <div className={styles.actions}>
                    <Button variant="primary" onClick={onSubmit}>
                        {submitLocale('start_setup')}
                    </Button>
                </div>
            </motion.div>
        </div>
    );
};

export default GetReady;
